import * as z from "../../../vendor/zod/src/index";
export default z.object({
    credential_token: z.string(),
    twofactor_check_token: z.string().optional().nullable(),
});
